import { Roles } from '@/utils/roles';
import { FeaturesEnum } from '@utils/features';
import { CashRegisterListPage, CashRegisterViewPage } from '../elements';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';
import label from '@/commons/label';

const ROOT = 'cash-register';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    title: ROOT,
    icon: 'system-uicons:boxes',
    custom: true,
    feature: FeaturesEnum.CASH_REGISTER,
    guard: [Roles.ADMIN, Roles.ATM],
  },
  viewCurrent: {
    path: pathJoin(root, [ROOT, 'view-current']),
    element: CashRegisterViewPage,
    feature: FeaturesEnum.CASH_REGISTER_DETAILS,
    params: undefined,
    guard: [Roles.ADMIN, Roles.ATM],
    title: 'view-current',
    label: 'view',
    show: true,
  },
  list: {
    path: pathJoin(root, [ROOT, 'list']),
    element: CashRegisterListPage,
    params: undefined,
    title: 'list',
    show: true,
    guard: [Roles.ADMIN],
    feature: FeaturesEnum.CASH_REGISTER_LIST,
  },
  view: {
    path: (name: string) => pathJoin(root, [ROOT, name]),
    element: CashRegisterViewPage,
    guard: [Roles.ADMIN, Roles.ATM],
    feature: FeaturesEnum.CASH_REGISTER_DETAILS,
    params: ':id',
  },

});

export const pathCashRegister = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
